import TransformShop from "../transforms/TransformShop";
import TransformAccount from "../transforms/TransformAccount";

export default new class StorageController {

    constructor() {
        this.keyBranches = "t1-branches";
        this.keyBranch = "t1-branch";
        this.keyCompany = "t1-company";
        this.keySplash = "t1-splash";
        this.keyAccount = "t1-account";
        this.keyCart = "t1-cart";
        this.keyCheckout = "t1-checkout";
        this.keyShowCard = "t1-show-card";
        this.keyAge = "t1-show-age";
        this.keyRedirectPath = "t1-rp";
        // this.keyCheckoutMap = "t1-checkout-map";
    }

    // storeRedirectPath(path = null) {
    //     if (!path) sessionStorage.removeItem(this.keyRedirectPath);
    //     else sessionStorage.setItem(this.keyRedirectPath, path);
    // }
    //
    // restoreRedirectPath() {
    //     return sessionStorage.getItem(this.keyRedirectPath);
    // }

    set(key, value) {
        localStorage.setItem(key, value);
    }

    get(key) {
        return localStorage.getItem(key);
    }

    token() {
        return this.restoreAccount().token;
    }

    isLogin() {
        return this.token() !== "";
    }

    storeAccount(value = null) {
        localStorage.setItem(this.keyAccount, JSON.stringify(TransformAccount.account(value)));
    }

    restoreAccount() {
        let account = localStorage.getItem(this.keyAccount);
        try {
            account = JSON.parse(account);
        } catch {
        }
        return TransformAccount.account(account);
    }

    storeCheckout(value = null) {
        localStorage.setItem(this.keyCheckout, JSON.stringify(TransformShop.checkout(value)));
    }

    restoreCheckout() {
        let checkout = localStorage.getItem(this.keyCheckout);
        try {
            checkout = JSON.parse(checkout);
        } catch {

        }
        return TransformShop.checkout(checkout);
    }

    storeCartId(value = 0) {
        sessionStorage.setItem(this.keyCart, value + "");
    }

    restoreCartId() {
        let id = sessionStorage.getItem(this.keyCart);
        return id === null ? -1 : +id;
    }

    storeCompanyId(value) {
        sessionStorage.setItem(this.keyCompany, value + "");
    }

    restoreCompanyId() {
        let id = sessionStorage.getItem(this.keyCompany);
        return id === null ? -1 : +id;
    }

    storeSplashId(value) {
        // sessionStorage.setItem(this.keySplash, value + "");
    }

    restoreSplashId() {
        return this.restoreCompanyId();
        // let id = sessionStorage.getItem(this.keySplash);
        // return id === null ? this.restoreCompanyId() : +id;
    }

    storeBranchId(value = -1) {
        sessionStorage.setItem(this.keyBranch, value + "");
    }

    restoreBranchId() {
        let id = sessionStorage.getItem(this.keyBranch);
        return id === null ? this.restoreCompanyId() : +id;
    }


    storeBranches(value = []) {
        sessionStorage.setItem(this.keyBranches, JSON.stringify(value));
    }

    restoreBranches() {
        let value = sessionStorage.getItem(this.keyBranches);
        try {
            return JSON.parse(value);
        } catch (e) {
            return [];
        }
    }

    toggleShowAsCard() {

        if (this.restoreShowAsCard()) {
            localStorage.setItem(this.keyShowCard, "list");
        } else {
            localStorage.setItem(this.keyShowCard, "card");
        }
    }

    setShowAsCard(value = 2) {
        let val = localStorage.getItem(this.keyShowCard);
        // console.log(`val : ${val}`);
        if (val === "card" || val === "list") return;
        localStorage.setItem(this.keyShowCard, (value + "") === "2" ? "card" : "list");
    }

    restoreShowAsCard() {

        return localStorage.getItem(this.keyShowCard) === "card";
    }

    restoreBasket() {

        return TransformShop.basket({id: this.restoreCartId()})

    }

    storeAge() {
        localStorage.setItem(this.keyAge, "ok");
    }

    showAgeModal() {
        return localStorage.getItem(this.keyAge) !== "ok";
    }

}();
